import { IClientConfig } from "src/client-config/config";
import { IUpperDataStore } from "src/stores/upperData";
import { composeAND, not } from "./strategy";
import { isPlaceBetAvailable } from "./bet";

export const isBookingAvailable = (config: IClientConfig, upperData: IUpperDataStore) => (
  config.enableBookingBet &&
  upperData.balance <= config.bookingBetBalanceMaxLimit &&
  !upperData.userId
);

export const isBookingOnlyMode = composeAND(
  isBookingAvailable,
  not(isPlaceBetAvailable)
);